import { readFunnelContext, writeFunnelContext } from './context';

/**
 * Preview with a KA-generated onboarding: hand it to the paywall the way the quiz does, so `paid`,
 * the email and post-payment read the same record. Runs before render — pages read the context on mount.
 */
export const seedPreviewOnboarding = (
  onboardingId: string | undefined,
  popupVariant: string | null | undefined,
  storage: Storage = sessionStorage,
): void => {
  if (!onboardingId) return;
  const current = readFunnelContext(storage);
  const paywallSlug = popupVariant || current?.paywallSlug || 'default';
  if (current?.onboardingId === onboardingId && current.paywallSlug === paywallSlug) return;
  writeFunnelContext({ ...current, paywallSlug, onboardingId }, storage);
};
